import React, { Component } from "react";

class AnswersQuestionsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHideAnswer: false,
        };
        this.showAnswer = this.showAnswer.bind(this);
    }

    showAnswer(event) {
        event.preventDefault();

        if (this.props.answersQuestions.Answer.Value) {
            this.setState({
                showHideAnswer: !this.state.showHideAnswer,
            });
        }
    }

    render() {
        // todo: structure is bad
        return (
            <dt
                className={
                    this.state.showHideAnswer
                        ? "faq__section--question active"
                        : "faq__section--question"
                }
                data-test="faq-question"
            >
                <h5
                    className={`${this.state.showHideAnswer ? "active" : ""}${
                        this.props.answersQuestions.Answer.Value
                            ? ""
                            : " faq__section--question--no--answer"
                    }`}
                    onClick={(event) => this.showAnswer(event)}
                >
                    {this.props.answersQuestions.Question.Value}
                </h5>

                {this.props.answersQuestions.Answer.Value ? (
                    <dd
                        className={
                            this.state.showHideAnswer
                                ? "faq__section--answer active"
                                : "faq__section--answer"
                        }
                        dangerouslySetInnerHTML={{
                            __html: this.props.answersQuestions.Answer.Value,
                        }}
                    ></dd>
                ) : null}
            </dt>
        );
    }
}
export default AnswersQuestionsComponent;
